
import AppEventcategoriesIndex from "./eventCategory.vue";
import AppEventcategoriesList from "./list/list.vue";
import AppEventcategoriesItem from "./item/item.vue";

const routes = [
  {
    path: "eventCategory",
    component: AppEventcategoriesIndex,
    meta: {
      auth: {
        roles: "eventCategory.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "eventCategory.index",
        component: AppEventcategoriesList,
        meta: {
          auth: {
            roles: "eventCategory.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "eventCategory.create",
        component: AppEventcategoriesItem,
        meta: {
          auth: {
            roles: "eventCategory.create",
            redirect: { name: "eventCategory.index" }
          }
        }
      },
      {
        path: ":id",
        name: "eventCategory.edit",
        component: AppEventcategoriesItem,
        meta: {
          auth: {
            roles: "eventCategory.update",
            redirect: { name: "eventCategory.index" }
          }
        }
      }
    ]
  }
];

export default routes;
